import axios from "axios";
import { ADMIN_SERVICE_URL, NOTIFICATION_SERVICE_URL } from "../app/configs";

import { encryptPayload, decryptPayload } from "../utils/crypto";

const handleUnauthorized = () => {
  window.location.replace("/");
  localStorage.removeItem("activeSession");
};

const createApiInstance = (baseURL, timeout = 300000) => {
  const IS_PROD =
    process.env.NODE_ENV === "production" ||
    process.env.REACT_APP_NODE_ENV === "production";

  const instance = axios.create({
    baseURL,
    timeout,
    headers: { "Content-Type": "application/json" },
  });

  instance.interceptors.request.use(
    (config) => {
      if (IS_PROD) {
        if (config.data && typeof config.data === "object") {
          try {
            const encryptedData = encryptPayload(config.data);
            config.data = { _d: encryptedData };
          } catch (err) {
            console.error("Failed to encrypt payload", err);
          }
        }

        // Encrypt query parameters
        if (config.params && Object.keys(config.params).length > 0) {
          try {
            const encryptedParams = encryptPayload(config.params);
            config.params = { q: encryptedParams };
          } catch (err) {
            console.error("Failed to encrypt query parameters", err);
          }
        }
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  instance.interceptors.response.use(
    (response) => {
      let { data } = response;

      if (data && data._d) {
        try {
          response.data = decryptPayload(data._d);
          data = response.data;
        } catch (err) {
          console.error("Failed to decrypt payload", err);
        }
      }

      // Automatically fix any live/dev database URLs that are blocked by proxy or VPN (DEV ONLY)
      if (!IS_PROD && response.data) {
        let dataStr = JSON.stringify(response.data);
        dataStr = dataStr.replace(
          /https?:\/\/[a-zA-Z0-9.-]+:5000\/uploads/g,
          "http://localhost:5000/uploads",
        );
        response.data = JSON.parse(dataStr);
      }

      if (
        localStorage?.getItem("languageVersion") !==
        response?.data?.languageVersion
      ) {
        localStorage.setItem("fetchLangResources", "true");
      }

      if (
        response.status === 401 ||
        (response.data && response.data.statusCode === 401)
      ) {
        handleUnauthorized();
        return Promise.reject(new Error("Unauthorized"));
      }
      return response;
    },
    (error) => {
      if (!error.response) {
        console.error("Server unreachable:", error?.message || error);

        return Promise.reject(new Error("Server unreachable"));
      }

      if (error.response.status === 401) {
        handleUnauthorized();
        return Promise.reject(new Error("Unauthorized"));
      }

      return Promise.reject(error);
    },
  );

  return instance;
};

export const serverApi = createApiInstance(`${ADMIN_SERVICE_URL}/`, 300000);
export const workflowServiceApi = createApiInstance(
  `${NOTIFICATION_SERVICE_URL}/`,
  90000,
);
